var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnergy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.836,
    viewBox: "0 0 18 14.836",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4,3.382l-.677.9a7.815,7.815,0,0,1,3.15,6.3,7.974,7.974,0,0,1-.069,1.051l1.114.149a9.007,9.007,0,0,0-3.518-8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.305,15.293H2.695a7.781,7.781,0,0,1-1.57-4.711A7.881,7.881,0,0,1,11.839,3.234l.406-1.049A9.005,9.005,0,0,0,0,10.582a8.9,8.9,0,0,0,1.981,5.626l.168.21h13.7l.168-.21a8.969,8.969,0,0,0,1.228-2.025l-1.031-.452A7.791,7.791,0,0,1,15.305,15.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,7.338l-4.629,2.6a1.671,1.671,0,0,0-1.038-.367,1.7,1.7,0,1,0,1.644,1.317l4.573-2.565ZM9.136,11.817a.562.562,0,1,1,.562-.562A.562.562,0,0,1,9.136,11.817Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnergy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/energy.84a902d2d8b49724982581a5787581d0.svg";